<template>
  <div>
    <CRow>
      <CCol md="12">

        <CRow>
          <CCol>
            <CCard>
              <CCardHeader>
                <CRow>
                  <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                    <strong>{{ $t("BusinessProfile") }}</strong>
                  </CCol>
                  <CCol col="4" style="text-align: end ;padding:0px 20px 0 20px ">
                    <CIcon @click.native="update_business_profile()" name="saveNew"/>
                  </CCol>

                </CRow>
              </CCardHeader>
              <CCardBody>
                <CInput
                    :label="$t('BusinessName')"
                    :value.sync="bissiness_profile.businessName"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                />
                <CInput
                    :label="$t('BusinessLine')"
                    :value.sync="bissiness_profile.businessLine"

                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                />
                <CInput
                    :label="$t('RegisteredNumber')"
                    :value.sync="bissiness_profile.registeredNo"

                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                />

                <CRow form class="form-group">
                  <CCol tag="label" sm="5" class="col-form-label">
                    {{ $t('RegisteredDate') }}
                  </CCol>
                  <CCol sm="7">
                    <date-picker
                        v-model="bissiness_profile.registeredDate"

                    ></date-picker>
                  </CCol>
                </CRow>

                <CRow form class="form-group">
                  <CCol tag="label" sm="5" class="col-form-label">
                    {{ $t('Logo') }}
                  </CCol>
                  <CCol sm="7">
                    <CInputFile
                        :label="$t('components.image')"
                        custom
                        horizontal
                        ref="file_selector"
                        v-show="false"

                        v-on:change="handleFileUpload"
                    />
                    <div class="text-center" v-on:click="open_file_selector()"
                    >
                      <CImg height="100px"
                            width="100%"
                            v-model="previewImage"
                            v-if="previewImage" :src="previewImage"
                      />
                    </div>

                  </CCol>
                </CRow>
                <!--                <CInputFile-->
                <!--                    :label="$t('Logo')"-->
                <!--                    custom-->
                <!--                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"-->
                <!--                />-->
              </CCardBody>
            </CCard>
          </CCol>
          <CCol >
            <CCard>
              <CCardHeader>
                <CRow>
                  <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                    <strong>{{ $t('MainAddress') }}</strong>
                  </CCol>
                  <CCol col="4" style="text-align: end ;padding:0px 20px 0 20px ">
                    <CIcon @click.native="update_main_address" name="saveNew"/>
                  </CCol>
                </CRow>
              </CCardHeader>
              <CCardBody v-if="local=='fa'">
                <CSelect
                    :label="$t('components.province')"
                    :value.sync="selected_province"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                    :options="province_items"
                />
                <CSelect
                    :label="$t('components.city')"
                    :value.sync="selected_city"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                    :options="city_items"
                />

                <CSelect
                    :label="$t('components.district')"
                    :value.sync="selected_district"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                    :options="district_items"
                />
                <CSelect
                    :label="$t('components.area')"
                    :value.sync="selected_area"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                    :options="area_items"
                >
                  <template #append-content>
                    <CIcon size="sm" v-on:click.native="go_to_add_modal('add_area')"
                           name="cil-plus"/>
                  </template>
                </CSelect>


<!--                <CInput-->
<!--                    :label="$t('Street')"-->
<!--                    :value.sync="main_address.Street"-->

<!--                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"-->
<!--                />-->
                <CInput
                    :label="$t('languageAddress')"
                    :value.sync="main_address.HouseNO"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                />
                <CInput
                    :label="$t('PostCode')"
                    :value.sync="main_address.PostCode"
                    placeholder="A-Z 0-9"
@keypress="isPostCode"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                >
<!--                  <template #append-content>-->
<!--                    <CIcon v-on:click.native="mapModal = true" class="text-white" name="cil-location-pin"/>-->

<!--                  </template>-->
                </CInput>
                <CSelect
                    :label="$t('Country')"
                    :value.sync="selected_country"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                    :options="country_items"
                />
              </CCardBody>
              <CCardBody v-if="local=='en'">
<!--                <CInput-->
<!--                    :label="$t('HouseNO')"-->
<!--                    :value.sync="main_address.HouseNO"-->
<!--                    -->
<!--                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"-->
<!--                />-->
                <CInput
                    :value.sync="main_address.HouseNO"
                    :label="$t('address')"
                    :placeholder="$t('languageAddress')"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                />

                <CSelect
                    :label="$t('components.province')"
                    :value.sync="selected_province"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                    :options="province_items"
                />
                <CSelect
                    :label="$t('components.city')"
                    :value.sync="selected_city"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                    :options="city_items"
                />

                <CSelect
                    :label="$t('town')"
                    :value.sync="selected_district"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                    :options="district_items"
                />
                <CSelect
                    :label="$t('components.area')"
                    :value.sync="selected_area"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                    :options="area_items"
                />

                <CInput
                    :label="$t('PostCode')"
                    :value.sync="main_address.PostCode"
                    placeholder="A-Z 0-9"
@keypress="isPostCode"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                >
<!--                  <template #append-content>-->
<!--                    <CIcon v-on:click.native="mapModal = true" class="text-white" name="cil-location-pin"/>-->

<!--                  </template>-->
                </CInput>
                <CSelect
                    :label="$t('Country')"
                    :value.sync="selected_country"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                    :options="country_items"
                />
              </CCardBody>
            </CCard>

          </CCol>
          <CCol>
            <CCard>
              <CCardHeader>
                <CRow>
                  <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                    <strong>{{ $t('Contacts') }}</strong>
                  </CCol>
                  <CCol col="4" style="text-align: end ;padding:0px 20px 0 20px ">
                    <CIcon @click.native="update_add_address(1)" name="saveNew"/>
                  </CCol>
                </CRow>
              </CCardHeader>
              <CCardBody style="max-height: 100px;overflow: auto">

                <div v-for="phone_obj in phone_objects" :key="phone_obj.row_id">
                  <CInput
                      class="m-0"
                      maxlength="11"
                      :placeholder="$t('components.number')"
                      :value.sync="phone_obj.phone"
                  >
                    <template #prepend-content>
                      <CIcon v-on:click.native="remove_phone_obj(phone_obj.row_id)" name="cil-minus"/>
                    </template>
                    <template #append-content>
                      <CIcon v-on:click.native="add_phone_obj()" name="cil-plus"/>
                    </template>
                  </CInput>

                </div>
              </CCardBody>
            </CCard>
            <CCard>
              <CCardHeader>
                <CRow>
                  <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                    <strong>{{ $t('Emails') }}</strong>
                  </CCol>
                  <CCol col="4" style="text-align: end ;padding:0px 20px 0 20px ">
                    <CIcon @click.native="update_add_address(2)" name="saveNew"/>
                  </CCol>
                </CRow>
              </CCardHeader>
              <CCardBody style="max-height: 100px;overflow: auto">

                <div v-for="phone_obj in email_objects" :key="phone_obj.row_id">
                  <CInput
                      class="m-0"
                      :placeholder="$t('EmailAddress')"
                      :value.sync="phone_obj.phone"
                  >
                    <template #prepend-content>
                      <CIcon v-on:click.native="remove_email_obj(phone_obj.row_id)" name="cil-minus"/>

                    </template>
                    <template #append-content>
                      <CIcon v-on:click.native="add_email_obj()" name="cil-plus"/>

                    </template>
                  </CInput>

                </div>
              </CCardBody>
            </CCard>
            <CCard>
              <CCardHeader>
                <CRow>
                  <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                    <strong>{{ $t('Websites') }}</strong>
                  </CCol>
                  <CCol col="4" style="text-align: end ;padding:0px 20px 0 20px ">
                    <CIcon @click.native="update_add_address(3)" name="saveNew"/>
                  </CCol>
                </CRow>
              </CCardHeader>
              <CCardBody style="max-height: 100px;overflow: auto">

                <div v-for="phone_obj in website_objects" :key="phone_obj.row_id">
                  <CInput
                      class="m-0"
                      :placeholder="$t('WebsiteAddress')"
                      :value.sync="phone_obj.phone"
                  >
                    <template #prepend-content>
                      <CIcon v-on:click.native="remove_website_obj(phone_obj.row_id)" name="cil-minus"/>

                    </template>
                    <template #append-content>
                      <CIcon v-on:click.native="add_website_obj()" name="cil-plus"/>

                    </template>
                  </CInput>

                </div>
              </CCardBody>
            </CCard>

          </CCol>
          <!--          <CCol>-->
          <!--            <CCard>-->
          <!--              <CCardHeader>-->
          <!--                <CRow>-->
          <!--                  <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">-->
          <!--                    <strong>Branches</strong>-->
          <!--                  </CCol>-->
          <!--                </CRow>-->
          <!--              </CCardHeader>-->
          <!--              <CCardBody>-->
          <!--                <CDataTable-->
          <!--                    :items="items"-->
          <!--                    :fields="fields"-->
          <!--border-->
          <!--                    striped-->
          <!--                    sorter-->
          <!--                    :items-per-page="20"-->
          <!--                    hover-->

          <!--                    pagination-->
          <!--                >-->
          <!--                  <template #row="{item}">-->

          <!--                    <td>-->
          <!--                      <p >{{ item.row_id + 1 }}</p>-->

          <!--                    </td>-->

          <!--                  </template>-->
          <!--                  <template #branchTitle="{item}">-->

          <!--                    <td>-->
          <!--                      <p >{{ item.branchTitle }}</p>-->

          <!--                    </td>-->

          <!--                  </template>-->

          <!--                  <template #provinceTitle="{item}">-->

          <!--                    <td>-->
          <!--                      <p >{{ item.provinceTitle }}</p>-->

          <!--                    </td>-->

          <!--                  </template>-->

          <!--                  <template #cityTitle="{item}">-->

          <!--                    <td>-->
          <!--                      <p >{{ item.cityTitle }}</p>-->

          <!--                    </td>-->

          <!--                  </template>-->


          <!--                  <template #operation="{item,index}">-->
          <!--                    <td>-->
          <!--                      <CButton class="m-1"-->
          <!--                               color="primary"-->
          <!--                               variant="outline"-->
          <!--                               square-->
          <!--                               size="sm"-->
          <!--                               :title="$t('buttons.edit')"-->
          <!--                               @click="edit_item(item)"-->
          <!--                      >-->
          <!--                        <CIcon name="cil-pencil"/>-->
          <!--                      </CButton>-->
          <!--                      <CButton class="m-1"-->
          <!--                               color="success"-->
          <!--                               variant="outline"-->
          <!--                               square-->
          <!--                               size="sm"-->
          <!--                               :title="$t('buttons.customers')"-->
          <!--                               @click="goSubCategories(item)"-->
          <!--                      >-->
          <!--                        <CIcon name="cil-people"/>-->
          <!--                      </CButton>-->
          <!--                      <CButton class="m-1"-->
          <!--                               color="danger"-->
          <!--                               variant="outline"-->
          <!--                               square-->
          <!--                               :title="$t('buttons.delete')"-->
          <!--                               size="sm"-->
          <!--                               @click="delete_item_dialog(item)"-->
          <!--                      >-->
          <!--                        <CIcon name="cilTrash"/>-->
          <!--                      </CButton>-->

          <!--                      <CButton class="m-1"-->
          <!--                               color="primary"-->
          <!--                               variant="outline"-->
          <!--                               square-->
          <!--                               :title="$t('buttons.organizationChart')"-->
          <!--                               size="sm"-->
          <!--                               @click="goChart(item)"-->
          <!--                      >-->
          <!--                        <CIcon name="cilApplications"/>-->
          <!--                      </CButton>-->
          <!--                    </td>-->
          <!--                  </template>-->


          <!--                </CDataTable>-->
          <!--                <CButton-->
          <!--               @click="$router.push({path:'/dashboard/base/branches'})"-->
          <!--                    size="sm"-->
          <!--                    color="secondary">شعبه جدید-->
          <!--                </CButton>-->
          <!--              </CCardBody>-->
          <!--            </CCard>-->

          <!--          </CCol>-->

        </CRow>

      </CCol>
    </CRow>
    <CModal
        :show.sync="mapModal"
        :no-close-on-backdrop="true"
        color="transparent"
        border-color="primary"
        :title="$t('components.map')"
    >

      <div :style="{ height: '250px'}" id='map'></div>

      <template #footer>
        <CButton
            @click="mapModal = false"
            color="danger"
        >{{ $t("buttons.close") }}
        </CButton>
      </template>
    </CModal>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

var items = [];

import moment from 'moment-jalaali'
import mapboxgl from "mapbox-gl";


export default {
  name: 'Login',
  components: {
  },
  data() {
    return {

      date_time_locale: this.$i18n.locale,
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      name: '',
      vat_date: '',
      date: '',

      mapModal: false,
      marker: null,
      map: null,

      local: this.$i18n.locale,
      file: null,
      color: '#ffffff',
      code: '',
      previewImage: '/img/placeholder.png',
      description: '',
      phone_objects: [{phone_type: 19, phone: '', row_id: 1}],
      email_objects: [{phone_type: 19, phone: '', row_id: 1}],
      website_objects: [{phone_type: 19, phone: '', row_id: 1}],
      bissiness_profile: {registeredDate: '', vATDate: '',},

      bissiness_profile_id: 0,
      main_address: {},
      main_address_id: 0,

      items: items.map((item, row_id) => {
        return {...item, row_id}
      }),
      fields: [
        {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:10%'},
        {key: 'branchTitle', label: this.$t('tables.name'), _style: 'width:70%'},
        // {key: 'provinceTitle', label: this.$t('tables.province'), _style: 'width:10%'},
        // {key: 'cityTitle', label: this.$t('tables.city'), _style: 'width:10%;'},
        // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
      ],
      details: [],
      collapseDuration: 0,
      status_form: 0,

      area_items: [],
      selected_area: 0,

      district_items: [],
      selected_district: 0,

      province_items: [],
      selected_province: 0,

      city_items: [],
      selected_city: 0,

      country_items: [],
      selected_country: 0,

      user_location_lat: 0,
      user_location_lng: 0,
    }
  }, mounted() {
    this.$root.root_validate_errors = [];
    this.get_provinces()
    this.get_country()
    this.get_bussiness_profile();
    this.get_main_address();
    this.get_contact();
    this.createMap();
    bus.$on('close_add_base_modal', (data) => {
      this.get_areas();
    });
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    'postCode': function () {
      this.main_address.PostCode = this.main_address.PostCode.toUpperCase();
    },
    '$route.params.cat_id': function () {
      this.get_lists();
    },
    'selected_province': function () {
      this.get_cities();
    },
    'selected_city': function () {
      this.get_districts();
    },
    'selected_district': function () {
      this.get_areas();
    },
    'selected_country': function () {
      this.get_provinces();
    },
  },
  methods: {
    go_to_add_modal(func) {
      bus.$emit("show_add_base_modal", func);
    },
    createMap() {
      var self = this;
      // init the map
      mapboxgl.accessToken = 'pk.eyJ1Ijoib21kZXNobyIsImEiOiJjanoyaW1zNG4wMHI1M2JteTQyZXhqaTI3In0.M0GJxZnal_ysW7mxXWEZLg';
      if(mapboxgl.getRTLTextPluginStatus()=="unavailable") {
          mapboxgl.setRTLTextPlugin(
                  'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
                  null,
                  true // Lazy load the plugin
          );
        }


      var center_loc = [51.37734351262877, 35.697451890638886];
      if (self.$i18n.locale == 'en') {
        center_loc = [-0.03880407284764019, 51.573360744046745];
      }
      self.map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
        center: center_loc,
        zoom: 14 // starting zoom
      });

      self.polygon_draw = new MapboxDraw({
        displayControlsDefault: false,
        controls: {
          polygon: true,
          trash: true
        }
      });
      // self.map.addControl(self.polygon_draw);
      // self.map.on('draw.create', self.updatePolygonArea);
      // self.map.on('draw.delete', self.updatePolygonArea);
      // self.map.on('draw.update', self.updatePolygonArea);

      // self.map.addControl(new mapboxgl.Navigation())
      self.map.on('click', function (e) {
        if (self.marker != null) {
          self.marker.remove();
        }
        // if (self.user_location_lat == 0) {

        self.marker = new mapboxgl.Marker({
          draggable: true
        })

            .setLngLat(e.lngLat)
            .addTo(self.map);
        self.user_location_lat = e.lngLat.lat;
        self.user_location_lng = e.lngLat.lng;

        // }

        function onDragEnd() {
          // var lngLat = marker.getLngLat();
          self.user_location_lat = self.marker.getLngLat().lat;
          self.user_location_lng = self.marker.getLngLat().lng;

        }

        function onDragStart() {
          // var lngLat = marker.getLngLat();
          console.log("drag started");
          self.user_location_lat = self.marker.getLngLat().lat;
          self.user_location_lng = self.marker.getLngLat().lng;

        }

        self.marker.on('dragend', onDragEnd);
        self.marker.on('dragstart', onDragStart);
        console.log('A click event has occurred at ' + e.lngLat);
        // }

      });

      self.map.on('load', function () {
        // self.show_polygon();
      });
    },

    add_phone_obj() {
      console.log('add clicked')

      this.phone_objects.push({row_id: 19, phone_type: 0, phone: ''})
      var copy = this.phone_objects;
      this.phone_objects = [];
      this.phone_objects = copy;

    },
    remove_phone_obj(index) {
      console.log('remove clicked')
      if (this.phone_objects.length > 1) {
        this.phone_objects.splice(index - 1, 1);
        var row_index = 1;
        this.phone_objects.forEach((val) => {
          val.row_id = row_index;
          row_index += 1;

        });

        var copy = this.phone_objects;
        this.phone_objects = [];
        this.phone_objects = copy;

      }
    },
    add_email_obj() {
      console.log('add clicked')

      this.email_objects.push({row_id: 19, phone_type: 0, phone: ''})
      var row_index = 1;
      this.email_objects.forEach((val) => {
        val.row_id = row_index;
        row_index += 1;

      });


      var copy = this.email_objects;
      this.email_objects = [];
      this.email_objects = copy;

    },
    remove_email_obj(index) {
      console.log('remove clicked')
      if (this.email_objects.length > 1) {
        this.email_objects.splice(index - 1, 1);
        var row_index = 1;
        this.email_objects.forEach((val) => {
          val.row_id = row_index;
          row_index += 1;

        });

        var copy = this.email_objects;
        this.email_objects = [];
        this.email_objects = copy;

      }
    },
    add_website_obj() {
      console.log('add clicked')

      this.website_objects.push({row_id: 19, phone_type: 0, phone: ''})
      var row_index = 1;
      this.website_objects.forEach((val) => {
        val.row_id = row_index;
        row_index += 1;

      });


      var copy = this.website_objects;
      this.website_objects = [];
      this.website_objects = copy;

    },
    remove_website_obj(index) {
      console.log('remove clicked')
      if (this.website_objects.length > 1) {
        this.website_objects.splice(index - 1, 1);
        var row_index = 1;
        this.website_objects.forEach((val) => {
          val.row_id = row_index;
          row_index += 1;

        });

        var copy = this.website_objects;
        this.website_objects = [];
        this.website_objects = copy;

      }
    },
    open_file_selector() {
      this.$refs.file_selector.$el.getElementsByTagName('input')[0].click()
    },
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.name != ''  && this.color != '') {
        return true;
      }


      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }

      if (this.color == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertColor'));
      }
      // if (this.description == '') {
      //   this.$root.root_validate_errors.push(this.$t('dialogs.insertSummary'));
      // }
      return false;
      // e.preventDefault();
    },
    get_image_file(item) {
      // console.log("image url is " + item.imageName);
      return this.$root.base_url + item.imageName;
    },

    get_bussiness_profile() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.bissiness_profile_id);


      axios.post('GetProfileById', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.bissiness_profile = content_data.data
          self.previewImage = localStorage.getItem("api_address")+"/images/Business/"+content_data.data.logo
       localStorage.setItem("businessName",content_data.data.businessName)
       localStorage.setItem("app_logo",localStorage.getItem("api_address")+"/images/Business/"+content_data.data.logo)
    document.getElementById("logo_image").src = localStorage.getItem("app_logo")
    document.getElementById("company_name").innerText = localStorage.getItem("businessName")

        } else {
          // self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_main_address() {
      var self = this;

      const formData = new FormData();

      formData.append('id', this.main_address_id);

      axios.post('GetAddressById', formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          // self.main_address = content_data.data.data

          self.main_address.HouseNO = content_data.data.houseNO
          self.main_address.Street = content_data.data.street
          self.main_address.PostCode = content_data.data.postCode
          self.selected_country = content_data.data.country
          self.selected_province = content_data.data.provience
          self.selected_city = content_data.data.city
          self.selected_district = content_data.data.regionId
          self.selected_area = content_data.data.areaId


        } else {
          // self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    get_contact() {
      var self = this;

      const formData = new FormData();

      formData.append('id', this.main_address_id);

      axios.post('GetContactById', formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          // self.main_address = content_data.data.data
            self.phone_objects= [{phone_type: 19, phone: '', row_id: 1}]
            self.email_objects= [{phone_type: 19, phone: '', row_id: 1}]
            self.website_objects= [{phone_type: 19, phone: '', row_id: 1}]
          if(content_data.data.length){
            self.phone_objects=[]
            self.email_objects=[]
            self.website_objects=[]

          }
          content_data.data.forEach((val) => {
            if (val.contactType == 1) {
              self.phone_objects.push({phone:val.contactText});
            }
            if (val.contactType == 2) {
              self.email_objects.push({phone:val.contactText});

            }
            if (val.contactType == 3) {
              self.website_objects.push({phone:val.contactText});

            }


          });
        } else {
          // self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    update_business_profile() {
      let self = this;
      const formData = new FormData();
      let url = "AddBusinessProfile";

      formData.append('BusinessName', this.bissiness_profile.businessName);
      formData.append('BusinessLine', this.bissiness_profile.businessLine);
      formData.append('RegisteredNo', this.bissiness_profile.registeredNo);
      formData.append('RegisteredDate', this.bissiness_profile.registeredDate);
      formData.append('VATNumber', this.bissiness_profile.vatNumber);
      formData.append('VATDate', this.bissiness_profile.vatDate);
      formData.append('Logo', this.file);

      formData.append('id', this.bissiness_profile_id);
      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);
        self.get_bussiness_profile()


      }).catch(function (error) {
        console.log(error);
      });

    },
    update_main_address() {
      let self = this;
      const formData = new FormData();
      let url = "AddBusinessAddress";

      formData.append('HouseNO', this.main_address.HouseNO);
      // formData.append('Street', this.main_address.Street);
      formData.append('Street', '');
      formData.append('Provience', this.selected_province);
      formData.append('City', this.selected_city);
      formData.append('AreaId', this.selected_area);
      formData.append('RegionId', this.selected_district);
      formData.append('Country', this.selected_country);
      formData.append('PostCode', this.main_address.PostCode);

      formData.append('id', this.main_address_id);
      axios.post(url, formData, {}).then((res) => {



        self.$root.modal_component.show_api_response_modals(res);


      }).catch(function (error) {
        console.log(error);
      });

    },
    update_add_address(type) {
      let self = this;
      const formData = new FormData();
      let url = "AddBusinessContact";
      var phones = [];

      for (var i = 0; i < this.phone_objects.length; i++) {
        // phones.push(this.phone_objects[i].phone)
        phones.push({ContactType: 1, ContactText: this.phone_objects[i].phone})
if(this.phone_objects[i].phone.length<11 && this.phone_objects[i].phone!=null && this.phone_objects[i].phone!=''){
  this.$root.root_validate_errors.push(this.$t('phoneMustBe11'));
return false;
}
      }

      for (i = 0; i < this.email_objects.length; i++) {
        phones.push({ContactType: 2, ContactText: this.email_objects[i].phone})

      }

      for (i = 0; i < this.website_objects.length; i++) {
        phones.push({ContactType: 3, ContactText: this.website_objects[i].phone})
      }
      formData.append('input', JSON.stringify(phones));
      // formData.append('ContactType', type);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);
self.get_contact()

      }).catch(function (error) {
        console.log(error);
      });

    },

    goSubCategories(item, index) {

      this.$router.push({path: '/dashboard/base/categories/' + this.items[index].recId});
    },
    goToProductList(item) {
      this.$router.push({path: "/dashboard/products/list-cat/" + item.recId})
    },
    handleFileUpload(files, e) {
      this.file = e.target.files[0];
      this.previewImage = URL.createObjectURL(this.file);
    },
    get_country() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetCountries', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.country_items = [];
          var obj = {label: self.$t('Country'), value: 0}
          self.country_items.push(obj);
          self.country_items = self.sort_array(
                  self.country_items, content_data.data,
                  'id','title');

          if(self.$i18n.locale=='fa'){
            self.selected_country = self.country_items.filter(x=> x.label=='ایران')[0].value
            // self.selected_country2 = self.country_items.filter(x=> x.label=='ایران')[0].value
          }
          if(self.$i18n.locale=='en'){
            self.selected_country = self.country_items.filter(x=> x.label=='England')[0].value
            // self.selected_country2 = self.country_items.filter(x=> x.label=='England')[0].value
          }

          // self.province_items = content_data.data;


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }


      }).catch(function (error) {

        console.log(error);
      });

    },
    get_provinces() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.selected_country);


      axios.post('GetStateList', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.province_items = [];
          var obj = {label: self.$t('dialogs.insertProvince'), value: 0}
          self.province_items.push(obj);
          self.province_items = self.sort_array(
                  self.province_items, content_data.data,
                  'id','provinceName');


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_cities() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.selected_province);

      axios.post('GetCityListByStateId', formData, {show_pros: true}).then(function (response) {

        var content_data = response.data;
        self.city_items = [];
        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          var obj = {label: self.$t('dialogs.insertCity'), value: 0}
          self.city_items.push(obj);
          self.city_items = self.sort_array(
                  self.city_items, content_data.data,
                  'cityId','cityName');


          // self.city_items = content_data.data;


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_areas() {
      var self = this;
      const formData = new FormData();

      formData.append('id', this.selected_district);

      axios.post('GetAreaTitlesByCityId', formData, {show_pros: true}).then(function (response) {
        self.area_items = [];
        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          var obj = {label: self.$t('dialogs.insertArea'), value: 0}
          self.area_items.push(obj);
          self.area_items = self.sort_array(
                  self.area_items, content_data.data,
                  'id','areaName');

          // content_data.data.forEach((val) => {
          //   var obj = {label: val.areaName, value: val.id}
          //
          //   self.area_items.push(obj);
          // });


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_districts() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.selected_city);

      axios.post('GetRegionByCityId', formData, {show_pros: true}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.district_items = []
          self.district_items = self.sort_array(
                  self.district_items, content_data.data,
                  'id','title');

          // content_data.data.forEach((val) => {
          //   var obj = {label: val.title, value: val.id};
          //   self.district_items.push(obj);
          //
          // });
          if (self.$route.params.user_id == null) {
            self.selected_district = self.district_items[0].value;
          }

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },


  }
}

</script>
<style>
.col-form-label {

  font-size: 11px !important;
}
</style>
